module.exports = __webpack_public_path__ + "static/media/safronova.b0d4b966.jpg";